/**
 * Application Entry Point
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import './i18n/config'; // Initialize i18n
import App from './App';
import { getToken } from '@/api/client';
import { publishAuthToken, registerMediaSw } from '@/sw/mediaSw';

/**
 * The media service worker (plan §6). Registered before the first paint and
 * handed whatever token `localStorage` already holds, because a reload lands on
 * a logged-in session that never passes through `login()` — without this, the
 * worker would sit tokenless until the next login and every preview would 401.
 *
 * Fire-and-forget on purpose: every media path has a degraded form (§6.5), so a
 * failed registration must not block the app from rendering.
 */
void registerMediaSw().then(() => publishAuthToken(getToken()));

const root = document.getElementById('root');

if (!root) {
  throw new Error('Root element not found');
}

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
